import React from 'react';
import { Button, Card, CardContent } from './ui';
import {
    ChevronRight
  } from 'lucide-react';
  
interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  onLearnMore: () => void;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ icon, title, description, onLearnMore }) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex flex-col items-center space-y-2 text-center">
          {icon}
          <h3 className="text-xl font-bold">{title}</h3>
          <p className="text-muted-foreground">{description}</p>
          <Button
            variant="link"
            className="inline-flex items-center text-sm font-medium text-primary hover:underline"
            onClick={onLearnMore}
          >
            Learn more <ChevronRight className="ml-1 h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;